<template>
  <div class="breadcrumb">
    <div class="crumb">
      <span>SAX</span>
      <span>&gt;</span>
    </div>

    <div class="crumb">
      <span>外汇</span>
      <span>&gt;</span>
    </div>
    <div class="crumb">
      <span>Japan(USD/JPY)</span>
    </div>
  </div>
</template>

<script>
  export default{
    props:{
      list:{
        type:Array,
        default(){
          return ['SAX']
        }
      }
    },
    data() {
      return {
        
      }
    },
  }
</script>

<style scoped>
.breadcrumb {
    width: 12rem;
    margin: auto;
    font-family: Mabry Pro;
    font-style: normal;
    font-weight: 400;
    font-size: .2rem;
    line-height: 100%;
    color: rgba(0,0,0,.5);
    margin-top: 1rem;
    height: .2rem
}

.breadcrumb .crumb {
    float: left
}

.breadcrumb .crumb span {
    margin: 0 .1rem
}
.breadcrumb:after {
    clear: both
}

</style>